import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { FuseConfigService, FUSE_CONFIG } from '../@fuse/services/config.service';
import { FuseTranslationLoaderService } from '../@fuse/services/translation-loader.service';
import { FuseProgressBarService } from '../@fuse/components/progress-bar/progress-bar.service';
import { FuseMatchMediaService } from '../@fuse/services/match-media.service';
import { FuseCopierService } from '../@fuse/services/copier.service';

import { routes } from './app.routes';
import { FlamingoHttpService } from '../@flamingo/service/flamingo-http.service';
import { FlamingoAuthService } from '../@flamingo/service/flamingo-auth.service';
import { FlamingoMessageService } from '../@flamingo/service/flamingo-message.service';
import { FlamingoAuthGuard } from '../@flamingo/service/flamingo-auth.guard';
import { FlamingoErrorHandler } from '../@flamingo/service/flamingo-error.handler';
import { flamingoHttpInterceptor } from '../@flamingo/service/flamingo-http.interceptor.function';
import { initializeApp } from './app.startup';
import { MainService } from './core/service/main.service';
import { fuseConfig } from './fuse-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([flamingoHttpInterceptor])),
    provideAnimations(),

    // Fuse Services
    FuseConfigService,
    FuseProgressBarService,
    FuseMatchMediaService,
    FuseCopierService,

    // Flamingo Services
    FlamingoHttpService,
    FlamingoAuthService,
    FlamingoMessageService,
    FlamingoAuthGuard,
    MainService,

    // JWT helpers
    {
      provide: JWT_OPTIONS,
      useValue: {
        tokenGetter: () => null
      }
    },
    JwtHelperService,


    {
      provide: ErrorHandler,
      useClass: FlamingoErrorHandler
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [FlamingoAuthService, MainService, Router],
    },
    {
      provide: FUSE_CONFIG,
      useValue: fuseConfig
    }
  ]
};
